// extracted by mini-css-extract-plugin
export var center = "_3v-2";
export var clickableRow = "_3v-5";
export var expandedRow = "_3v-7";
export var hoverable = "_3v-4";
export var left = "_3v-1";
export var right = "_3v-3";
export var row = "_3v-0";
export var selectedRow = "_3v-6";
export var summaryRow = "_3v-8";